import { CheckoutSessionCart } from '@/modules/billing/models/CheckoutSessionCart';
import { StripeCheckoutSession } from '@/modules/billing/models/stripe/StripeCheckoutSession';
import { GenericEntityResource } from '@/modules/core/app/resources/GenericEntityResource';
import { BaseResourceService } from '@/modules/core/app/services/abstracts/BaseResourceService';
import { Route } from '/@/modules/core/app/constants/api.constants';

export class FinancialAdvisorCheckoutService extends BaseResourceService {
  resource: GenericEntityResource;

  constructor() {
    super();
    this.resource = new GenericEntityResource(this.getRoute(), this.getModel());
  }

  getRoute(): string {
    return Route.BILLINGS_ADVISOR_CREATECHECKOUTSESSION;
  }

  getModel(): typeof StripeCheckoutSession {
    return StripeCheckoutSession;
  }

  async createSession(data: CheckoutSessionCart): Promise<StripeCheckoutSession> {
    const response: Record<string, unknown> = await this.resource.saveItem(data, null);

    return new StripeCheckoutSession(response);
  }
}

export default new FinancialAdvisorCheckoutService();
